import React from 'react';
import styled from 'styled-components';

const AlertBox = styled.div`
  background:${p => p.theme.colors.error.bg};
  color:${p => p.theme.colors.error.text};
  border-radius:${p => p.theme.radius.md}px;
  padding:${p => p.theme.spacing[3]}px ${p => p.theme.spacing[4]}px;
  margin:${p => p.theme.spacing[3]}px 0;
  display:flex;align-items:center;justify-content:space-between;
  font-size:${p => p.theme.typography.sizes.sm};
`;
const DismissBtn = styled.button`
  border:none;background:transparent;
  color:${p => p.theme.colors.error.text};
  cursor:pointer;font-size:1.1rem;padding:0 4px;font-weight:${p => p.theme.typography.weights.bold};
`;

export default function ErrorAlert({ message, onDismiss }) {
  if (!message) return null;
  return (
    <AlertBox role="alert">
      <span>{message}</span>
      {onDismiss && <DismissBtn onClick={onDismiss} aria-label="Dismiss error">×</DismissBtn>}
    </AlertBox>
  );
}
